import CCPA from './CCPA';

export default CCPA;
